const state = {
  userId: sessionStorage.getItem('userId') || '',
  userName: sessionStorage.getItem('userName') || '',
  villageId: sessionStorage.getItem('villageId') || '',
  villageName: sessionStorage.getItem('villageName') || '',
  villageAddress: sessionStorage.getItem('villageAddress') || '',
  username: sessionStorage.getItem('username') || '',
  password: sessionStorage.getItem('password') || '',
  dlevelcode: sessionStorage.getItem('dlevelcode') || ''
}

const mutations = {
  userDetail (state, data) {
    state.userId = data.userId
    state.userName = data.userName
    state.villageId = data.villageId
    state.villageName = data.villageName
    state.villageAddress = data.villageAddress
    state.username = data.username
    state.password = data.password
    state.dlevelcode = data.dlevelcode
    sessionStorage.setItem('userId', state.userId)
    sessionStorage.setItem('userName', state.userName)
    sessionStorage.setItem('villageId', state.villageId)
    sessionStorage.setItem('villageName', state.villageName)
    sessionStorage.setItem('villageAddress', state.villageAddress)
    sessionStorage.setItem('username', state.username)
    sessionStorage.setItem('password', state.password)
    sessionStorage.setItem('dlevelcode', state.dlevelcode)
  }
}

const actions = {
  userDetail (context, data) {
    context.commit('userDetail', data)
  }
}

export default{
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js